import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate, formatMoney } from '../../utils/format';
import { orderPickerLabel } from './orderPickerLabel.mjs';

// Hook face of the shared order-picker label: Open / Done come from the existing customerCreditNote lifecycle strings
// (open -> Open, closed -> Done; any other lifecycle shows as-is), dates and amounts from Settings > Formatting.
export default function useOrderPickerLabel() {
  const { t } = useTranslation('customerCreditNote');
  return useCallback((o, opts) => orderPickerLabel(o, {
    fmtDate: formatDate, fmtMoney: formatMoney, statusLabel: (s) => t('lifecycle.' + s, { defaultValue: s }), ...opts }), [t]);
}
